export enum UserProviderType {
  INTERNAL = "Internal",
  HRIS = "HRIS",
  AZURE = "Azure",
  GOOGLE = "Google",
  SAML = "SAML",
  SCIM = "SCIM",
}
